document.addEventListener('DOMContentLoaded', function () {
    const CONFIG = {
        HORA_CORTE: 11,
        HORA_INICIO_OPORTUNIDAD: 0,
        DEBUG_MODE: window.location.search.includes('debug=true'),
        FUERZA_MAYOR: false,
        ZONA_HORARIA: 'America/Santiago'
    };

    let elementos = {};
    let animationId = null;
    let mockTime = null;
    let mockStartTime = null;
    let estadoActual = '';

    const festivosChile = [
        '2026-01-01', '2026-04-03', '2026-04-04', '2026-05-01', '2026-05-21',
        '2026-06-21', '2026-06-29', '2026-07-16', '2026-08-15', '2026-09-18',
        '2026-09-19', '2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08',
        '2026-12-25'
    ];

    const Logger = {
        logs: [],
        maxLogs: 50,
        log(tipo, mensaje, datos = {}) {
            if (!CONFIG.DEBUG_MODE) return;
            const entry = { timestamp: new Date().toISOString(), tipo, mensaje, datos };
            this.logs.push(entry);
            if (this.logs.length > this.maxLogs) this.logs.shift();
            console.log(`[${tipo}] ${mensaje}`, datos);
        },
        clear() { this.logs = []; }
    };

    function inicializarElementos() {
        const container = document.querySelector('.temporizador');
        if (container) {
            CONFIG.HORA_CORTE = parseInt(container.dataset.horaCorte) || 11;
            CONFIG.FUERZA_MAYOR = container.dataset.fuerzaMayor === 'true';
        }

        elementos = {
            container: container,
            reloj: document.getElementById('temporizador-reloj'),
            etiqueta: document.getElementById('temporizador-etiqueta'),
            etiquetaEntrega: document.getElementById('temporizador-entrega'),
            fecha: document.getElementById('temporizador-fecha'),
            informacion: document.getElementById('temporizador-info'),
            alerta: document.querySelector('.temporizador__alerta')
        };

        if (elementos.reloj) {
            elementos.digitos = elementos.reloj.querySelectorAll('.temporizador__digito');
            elementos.milisegundos = elementos.reloj.querySelector('.temporizador__milisegundos');
            elementos.unidad = elementos.reloj.querySelector('.temporizador__unidad');
        }

        if (CONFIG.FUERZA_MAYOR) {
            aplicarFuerzaMayor(true);
        }

        Logger.log('INIT', 'Elementos inicializados', { horaCorte: CONFIG.HORA_CORTE, fuerzaMayor: CONFIG.FUERZA_MAYOR });
    }

    function esFestivo(fecha) {
        const fechaStr = fecha.toISOString().split('T')[0];
        return festivosChile.includes(fechaStr);
    }

    function obtenerProximoDiaHabil(fecha) {
        let proximoDia = new Date(fecha);
        proximoDia.setDate(proximoDia.getDate() + 1);
        let diasSaltados = 0;
        while (proximoDia.getDay() === 0 || esFestivo(proximoDia)) {
            proximoDia.setDate(proximoDia.getDate() + 1);
            diasSaltados++;
            if (diasSaltados > 10) break;
        }
        return proximoDia;
    }

    function obtenerHoraActual() {
        if (mockTime) {
            const tiempoTranscurrido = mockStartTime ? Date.now() - mockStartTime : 0;
            return new Date(mockTime.getTime() + tiempoTranscurrido);
        }
        return new Date();
    }

    function esHoraOportunidad(hora, diaSemana) {
        if (diaSemana === 0 || esFestivo(hora)) return false;
        const horaActual = hora.getHours();
        return horaActual >= CONFIG.HORA_INICIO_OPORTUNIDAD && horaActual < CONFIG.HORA_CORTE;
    }

    function actualizarDigitos(h, m, s, ms) {
        if (elementos.digitos && elementos.digitos.length >= 3) {
            elementos.digitos[0].textContent = String(h).padStart(2, '0');
            elementos.digitos[1].textContent = String(m).padStart(2, '0');
            elementos.digitos[2].textContent = String(s).padStart(2, '0');
        }
        if (elementos.milisegundos) {
            elementos.milisegundos.textContent = String(Math.floor(ms / 10)).padStart(2, '0');
        }
    }

    function determinarUnidadTiempo(h, m, s) {
        if (h > 0) return h === 1 ? 'Hora' : 'Horas';
        if (m > 0) return m === 1 ? 'Minuto' : 'Minutos';
        return s === 1 ? 'Segundo' : 'Segundos';
    }

    function formatearFechaCompleta(fecha) {
        const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return `${dias[fecha.getDay()]} ${fecha.getDate()} de ${meses[fecha.getMonth()]}`;
    }

    function mostrarReloj(mostrar) {
        if (elementos.reloj) {
            elementos.reloj.classList.toggle('temporizador__reloj--oculto', !mostrar);
        }
    }

    function actualizarTextoEntrega(texto) {
        if (elementos.etiquetaEntrega) {
            elementos.etiquetaEntrega.textContent = texto;
        }
    }

    function aplicarEstiloOportunidad(aplicar) {
        if (elementos.container) {
            elementos.container.classList.toggle('temporizador--oportunidad', aplicar);
        }
    }

    function aplicarFuerzaMayor(aplicar) {
        if (elementos.container) {
            elementos.container.classList.toggle('temporizador--fuerza-mayor', aplicar);
        }
        if (elementos.alerta) {
            elementos.alerta.classList.toggle('temporizador__alerta--oculta', !aplicar);
        }
        mostrarReloj(!aplicar);
    }

    function actualizarTemporizador() {
        try {
            const horaChile = obtenerHoraActual();
            const horaActual = horaChile.getHours();
            const minutosActual = horaChile.getMinutes();
            const segundosActual = horaChile.getSeconds();
            const milisegundosActual = horaChile.getMilliseconds();
            const diaSemana = horaChile.getDay();

            let mensajeEntrega = '';
            let claseInfo = '';
            let estado = '';
            const esOportunidad = esHoraOportunidad(horaChile, diaSemana);

            aplicarEstiloOportunidad(esOportunidad && !CONFIG.FUERZA_MAYOR);

            if (CONFIG.FUERZA_MAYOR) {
                mostrarReloj(false);
                if (elementos.etiqueta) elementos.etiqueta.textContent = 'Servicio suspendido';
                actualizarTextoEntrega('Tiempo estimado de entrega:');
                mensajeEntrega = '24 a 72 horas hábiles';
                claseInfo = 'temporizador__informacion--cerrado';
                estado = 'FUERZA_MAYOR';
            } else if (diaSemana === 0) {
                const proximoDiaHabil = obtenerProximoDiaHabil(horaChile);
                mostrarReloj(false);
                if (elementos.etiqueta) elementos.etiqueta.textContent = 'No hay entregas hoy';
                actualizarTextoEntrega('Próxima entrega disponible:');
                mensajeEntrega = formatearFechaCompleta(proximoDiaHabil);
                claseInfo = 'temporizador__informacion--cerrado';
                estado = 'DOMINGO';
            } else if (esFestivo(horaChile)) {
                const proximoDiaHabil = obtenerProximoDiaHabil(horaChile);
                mostrarReloj(false);
                if (elementos.etiqueta) elementos.etiqueta.textContent = 'No hay entregas hoy por feriado';
                actualizarTextoEntrega('Próxima entrega disponible:');
                mensajeEntrega = formatearFechaCompleta(proximoDiaHabil);
                claseInfo = 'temporizador__informacion--cerrado';
                estado = 'FESTIVO';
            } else if (horaActual < CONFIG.HORA_CORTE) {
                mostrarReloj(true);

                const ahora = horaChile.getTime();
                const corte = new Date(horaChile);
                corte.setHours(CONFIG.HORA_CORTE, 0, 0, 0);

                const diferencia = corte - ahora;
                const horas = Math.floor(diferencia / (1000 * 60 * 60));
                const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
                const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
                const milisegundos = diferencia % 1000;

                actualizarDigitos(horas, minutos, segundos, milisegundos);

                const unidadTiempo = determinarUnidadTiempo(horas, minutos, segundos);

                if (elementos.etiqueta) {
                    if (esOportunidad) {
                        elementos.etiqueta.textContent = '¡Última oportunidad para hoy!';
                    } else {
                        elementos.etiqueta.textContent = horas > 0 ? 'Pide en las próximas:' : 'Pide en los próximos:';
                    }
                }

                if (elementos.unidad) elementos.unidad.textContent = unidadTiempo;
                actualizarTextoEntrega('Llega:');
                mensajeEntrega = `<span class="dia">Hoy ✨</span><br> ${formatearFechaCompleta(horaChile)}`;
                claseInfo = '';
                estado = 'ENTREGA_HOY';
            } else {
                mostrarReloj(true);
                const proximoDiaHabil = obtenerProximoDiaHabil(horaChile);
                const proximaEntrega = new Date(proximoDiaHabil);
                proximaEntrega.setHours(CONFIG.HORA_CORTE, 0, 0, 0);

                const diferencia = proximaEntrega - horaChile;
                const horas = Math.floor(diferencia / (1000 * 60 * 60));
                const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
                const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
                const milisegundos = diferencia % 1000;

                actualizarDigitos(horas, minutos, segundos, milisegundos);

                const unidadTiempo = determinarUnidadTiempo(horas, minutos, segundos);

                if (elementos.etiqueta) {
                    elementos.etiqueta.textContent = horas > 0 ? 'Pide en las próximas:' : 'Pide en los próximos:';
                }

                if (elementos.unidad) elementos.unidad.textContent = unidadTiempo;
                actualizarTextoEntrega('Llega:');

                const diasHastaEntrega = Math.ceil((proximoDiaHabil - horaChile) / (1000 * 60 * 60 * 24));
                mensajeEntrega = diasHastaEntrega === 1 ? `<span class="dia">Mañana</span><br> ${formatearFechaCompleta(proximoDiaHabil)}` : formatearFechaCompleta(proximoDiaHabil);
                claseInfo = 'temporizador__informacion--manana';
                estado = 'ENTREGA_PROXIMO_DIA';
            }

            if (elementos.fecha) elementos.fecha.innerHTML = mensajeEntrega;
            if (elementos.informacion) elementos.informacion.className = 'temporizador__informacion ' + claseInfo;

            if (estado !== estadoActual) {
                estadoActual = estado;
                Logger.log('ESTADO', `Estado: ${estado}`, { mensajeEntrega, esOportunidad });
            }
        } catch (error) {
            Logger.log('ERROR', 'Error en actualizarTemporizador', { error: error.message });
        }
    }

    function animationLoop() {
        actualizarTemporizador();
        animationId = requestAnimationFrame(animationLoop);
    }

    function ejecutarAccionDebug(action) {
        Logger.log('DEBUG', `Acción: ${action}`);
        const ahora = new Date();

        switch (action) {
            case 'medianoche':
                mockTime = new Date();
                mockTime.setHours(0, 30, 0, 0);
                if (mockTime.getDay() === 0) mockTime.setDate(mockTime.getDate() + 1);
                mockStartTime = Date.now();
                break;
            case 'manana-temprano':
                mockTime = new Date();
                mockTime.setHours(6, 0, 0, 0);
                if (mockTime.getDay() === 0) mockTime.setDate(mockTime.getDate() + 1);
                mockStartTime = Date.now();
                break;
            case 'dia-manana':
                mockTime = new Date();
                mockTime.setHours(9, 0, 0, 0);
                if (mockTime.getDay() === 0) mockTime.setDate(mockTime.getDate() + 1);
                if (mockTime.getDay() === 6) mockTime.setDate(mockTime.getDate() + 2);
                mockStartTime = Date.now();
                break;
            case 'ultimo-minuto':
                mockTime = new Date();
                mockTime.setHours(CONFIG.HORA_CORTE - 1, 55, 0, 0);
                if (mockTime.getDay() === 0) mockTime.setDate(mockTime.getDate() + 1);
                if (mockTime.getDay() === 6) mockTime.setDate(mockTime.getDate() + 2);
                mockStartTime = Date.now();
                break;
            case 'dia-tarde':
                mockTime = new Date();
                mockTime.setHours(15, 0, 0, 0);
                if (mockTime.getDay() === 0) mockTime.setDate(mockTime.getDate() + 1);
                if (mockTime.getDay() === 6) mockTime.setDate(mockTime.getDate() + 2);
                mockStartTime = Date.now();
                break;
            case 'domingo':
                mockTime = new Date();
                while (mockTime.getDay() !== 0) mockTime.setDate(mockTime.getDate() + 1);
                mockTime.setHours(14, 0, 0, 0);
                mockStartTime = Date.now();
                break;
            case 'festivo':
                mockTime = new Date(ahora.getFullYear() + 1, 0, 1, 14, 0, 0);
                mockStartTime = Date.now();
                break;
            case 'fuerza-mayor':
                CONFIG.FUERZA_MAYOR = !CONFIG.FUERZA_MAYOR;
                aplicarFuerzaMayor(CONFIG.FUERZA_MAYOR);
                Logger.log('DEBUG', `Fuerza mayor: ${CONFIG.FUERZA_MAYOR ? 'ACTIVADA' : 'DESACTIVADA'}`);
                break;
            case 'reset':
                mockTime = null;
                mockStartTime = null;
                CONFIG.FUERZA_MAYOR = false;
                aplicarFuerzaMayor(false);
                aplicarEstiloOportunidad(false);
                Logger.log('DEBUG', 'Reset a tiempo real');
                break;
        }

        if (mockTime) Logger.log('DEBUG', `Tiempo simulado: ${mockTime.toLocaleString()}`);
        actualizarTemporizador();
    }

    window.TemporizadorDebug = {
        simular: {
            medianoche: () => ejecutarAccionDebug('medianoche'),
            madrugada: () => ejecutarAccionDebug('manana-temprano'),
            diaMañana: () => ejecutarAccionDebug('dia-manana'),
            ultimoMinuto: () => ejecutarAccionDebug('ultimo-minuto'),
            diaTarde: () => ejecutarAccionDebug('dia-tarde'),
            domingo: () => ejecutarAccionDebug('domingo'),
            festivo: () => ejecutarAccionDebug('festivo'),
            fuerzaMayor: () => ejecutarAccionDebug('fuerza-mayor'),
            reset: () => ejecutarAccionDebug('reset')
        },
        estado: () => {
            const hora = obtenerHoraActual();
            return {
                horaActual: hora.toLocaleString(),
                diaSemana: hora.getDay(),
                esFestivo: esFestivo(hora),
                fuerzaMayor: CONFIG.FUERZA_MAYOR,
                esOportunidad: esHoraOportunidad(hora, hora.getDay()),
                estadoActual,
                mockTime: mockTime ? mockTime.toLocaleString() : null,
                horaCorte: CONFIG.HORA_CORTE
            };
        },
        logs: () => Logger.logs,
        limpiarLogs: () => Logger.clear(),
        config: {
            setHoraCorte: (hora) => {
                CONFIG.HORA_CORTE = hora;
                Logger.log('CONFIG', `Hora de corte: ${hora}`);
                actualizarTemporizador();
            },
            toggleDebug: () => {
                CONFIG.DEBUG_MODE = !CONFIG.DEBUG_MODE;
                Logger.log('CONFIG', `Debug mode: ${CONFIG.DEBUG_MODE}`);
            }
        },
        agregarFestivo: (fecha) => {
            festivosChile.push(fecha);
            Logger.log('CONFIG', `Festivo agregado: ${fecha}`);
            actualizarTemporizador();
        }
    };

    function iniciar() {
        inicializarElementos();
        actualizarTemporizador();
        animationId = requestAnimationFrame(animationLoop);

        if (CONFIG.DEBUG_MODE) {
            console.log('%c🎯 TEMPORIZADOR DEBUG', 'color: #22c55e; font-size: 16px; font-weight: bold;');
            console.log('TemporizadorDebug.simular.medianoche()');
            console.log('TemporizadorDebug.simular.madrugada()');
            console.log('TemporizadorDebug.simular.diaMañana()');
            console.log('TemporizadorDebug.simular.ultimoMinuto()');
            console.log('TemporizadorDebug.simular.diaTarde()');
            console.log('TemporizadorDebug.simular.domingo()');
            console.log('TemporizadorDebug.simular.festivo()');
            console.log('TemporizadorDebug.simular.fuerzaMayor()');
            console.log('TemporizadorDebug.simular.reset()');
            console.log('TemporizadorDebug.estado()');
        }
    }

    window.addEventListener('beforeunload', function () {
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
    });

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            if (animationId) {
                cancelAnimationFrame(animationId);
                animationId = null;
            }
        } else {
            if (!animationId) {
                animationId = requestAnimationFrame(animationLoop);
            }
        }
    });

    iniciar();
});